<i18n>
{
  "fr": {
    "this-price-includes": "Ce prix comprend",
    "adult": "{count} Adulte | {count} Adultes",
    "adult-tax": "{count} Adulte avec les taxes | {count} Adultes avec les taxes",
    "children": "{count} Enfant | {count} Enfants",
    "children-tax": "{count} Enfant avec les taxes | {count} Enfants avec les taxes",
    "infant": "{count} Bébé | {count} Bébés",
    "infant-tax": "{count} Bébé avec les taxes | {count} Bébés avec les taxes",
    "total-tax": "Taxes",
    "handling-fee": "Frais de dossier"
  },
  "en": {
    "this-price-includes": "This price includes",
    "adult": "{count} Adult | {count} Adults",
    "adult-tax": "{count} Adult with taxes | {count} Adults with taxes",
    "children": "{count} Children | {count} Children",
    "children-tax": "{count} Children with taxes | {count} Children with taxes",
    "infant": "{count} Infant | {count} Infants",
    "infant-tax": "{count} Infant with taxes | {count} Infants with taxes",
    "total-tax": "Taxes",
    "handling-fee": "Handling fee"
  }
}
</i18n>

<template>
  <div>
    <span>{{ $t('this-price-includes') }} :</span><br>
    <ul class="pt-1">
      <li
        v-if="pricePerTypeOfPassenger(pp).adult"
        id="adult-price-details"
        class="caption"
      >
        <v-row no-gutters>
          <v-col
            v-if="parseFloat(pp.total_tax) > 0"
            cols="7"
          >
            {{ $tc('adult', pricePerTypeOfPassenger(pp).adultAmount) }}
          </v-col>
          <v-col
            v-else
            cols="7"
          >
            {{ $tc('adult-tax', pricePerTypeOfPassenger(pp).adultAmount) }}
          </v-col>
          <v-spacer />
          <v-col class="ml-auto">
            {{ pricePerTypeOfPassenger(pp).adult }}
          </v-col>
        </v-row>
      </li>
      <li
        v-if="pricePerTypeOfPassenger(pp).children"
        id="children-price-details"
        class="caption"
      >
        <v-row no-gutters>
          <v-col
            v-if="parseFloat(pp.total_tax) > 0"
            cols="7"
          >
            {{ $tc('children', pricePerTypeOfPassenger(pp).childrenAmount) }}
          </v-col>
          <v-col
            v-else
            cols="7"
          >
            {{ $tc('children-tax', pricePerTypeOfPassenger(pp).childrenAmount) }}
          </v-col>
          <v-spacer />
          <v-col>
            {{ pricePerTypeOfPassenger(pp).children }}
          </v-col>
        </v-row>
      </li>
      <li
        v-if="pricePerTypeOfPassenger(pp).infant"
        id="infant-price-details"
        class="caption"
      >
        <v-row no-gutters>
          <v-col
            v-if="parseFloat(pp.total_tax) > 0"
            cols="7"
          >
            {{ $tc('infant', pricePerTypeOfPassenger(pp).infantAmount) }}
          </v-col>
          <v-col
            v-else
            cols="7"
          >
            {{ $tc('infant-tax', pricePerTypeOfPassenger(pp).infantAmount) }}
          </v-col>
          <v-spacer />
          <v-col>
            {{ pricePerTypeOfPassenger(pp).infant }}
          </v-col>
        </v-row>
      </li>
      <li
        v-if="parseFloat(pp.total_tax) > 0"
        id="total-tax-price-details"
        class="caption"
      >
        <v-row no-gutters>
          <v-col cols="7">
            {{ $t('total-tax') }}
          </v-col>
          <v-spacer />
          <v-col>
            {{ formatPriceWithCode(pp.total_tax, pp.currency) }}
          </v-col>
        </v-row>
      </li>
      <li
        id="handling-fee-price-details"
        class="caption"
      >
        <v-row no-gutters>
          <v-col cols="7">
            {{ $t('handling-fee') }}
          </v-col>
          <v-spacer />
          <v-col>
            {{ formatPriceWithCode(pp.dossier, pp.currency) }}
          </v-col>
        </v-row>
      </li>
    </ul>
  </div>
</template>

<script>
import globalMixin from '@/mixins/global'

export default {
  name: 'DetailsCardPriceIncludes',
  mixins: [globalMixin],
  props: {
    pp: {
      type: Object,
      required: true
    }
  },
  methods: {
    /**
     * Return a big object used in various places of the template
     * @return {{childrenAmount: number, children: string, infantAmount: number, adult: string, infant: string, adultAmount: number}}
     */
    pricePerTypeOfPassenger (pp) {
      let adultTotal = 0
      let adultAmount = 0
      let childrenTotal = 0
      let childrenAmount = 0
      let infantTotal = 0
      let infantAmount = 0
      const currency = pp.currency

      for (const price of pp.passengers_prices) {
        if (price.code === 'ADT') {
          adultTotal += parseFloat(price.total) * parseFloat(price.quantity)
          adultAmount += price.quantity
        } else if (price.code === 'CNN') {
          childrenTotal += parseFloat(price.total) * parseFloat(price.quantity)
          childrenAmount += price.quantity
        } else if (price.code === 'INF') {
          infantTotal += parseFloat(price.total) * parseFloat(price.quantity)
          infantAmount += price.quantity
        }
      }

      let formatAdult
      if (adultAmount > 0) {
        formatAdult = this.formatPriceWithCode(adultTotal, currency)
      } else {
        formatAdult = undefined
      }

      let formatChildren
      if (childrenAmount > 0) {
        formatChildren = this.formatPriceWithCode(childrenTotal, currency)
      } else {
        formatChildren = undefined
      }

      let formatInfant
      if (infantAmount > 0) {
        formatInfant = this.formatPriceWithCode(infantTotal, currency)
      } else {
        formatInfant = undefined
      }

      return {
        adult: formatAdult,
        adultAmount: adultAmount,
        children: formatChildren,
        childrenAmount: childrenAmount,
        infant: formatInfant,
        infantAmount: infantAmount
      }
    }
  }
}
</script>

<style scoped>
</style>
